import useIsMobile from "../isMobile/IsMobile";

const JoinUs = () => {
  const cards = [
    { title: "Personal Attention" },
    { title: "Interactive Classes" },
    { title: "Supportive Teachers" },
    { title: "Guiding Little Minds" },
    { title: "Learning Together" },
  ];

  const isMobile = useIsMobile(768);

  return (
    <div
      style={{
        marginTop: isMobile ? 50 : 100,
        display: "flex",
        flexDirection: "column", // stack vertically
        justifyContent: "center",
        alignItems: "center", 
      }}
    >
      {/* Title */}
      <div
        style={{
          fontFamily: "Nexa-Bold",
          fontSize: isMobile ? 24 : 30,
          zIndex: 10,
          color: "white",
          marginBottom: 12,
        }}
      >
        Join the Little Learners Family
      </div>

      {/* Subtitle */}
      <p
        className=""
        style={{
          fontFamily: "Nexa-Regular",
          fontSize: isMobile ? 16 : 18,
          zIndex: 10,
          marginBottom: 30,
          color:"white",
        }}
      >
        Grow, Read, and Shine Bright!
      </p>

      {/* Cards */}
      <div
        className="flex flex-wrap justify-center"
        style={{ gap: 20, zIndex: 10, marginBottom: 30 }}
      >
        {cards.map((card, idx) => (
          <div
            key={idx}
            className="bg-green-300 rounded-sm"
            style={{ zIndex: 10, padding:8 ,}}
          >
            <p
              style={{
                fontFamily: "Nexa-Heavy",
                fontSize: 14,
                color: "black",
              }}
            >
              {card.title}
            </p>
          </div>
        ))}
      </div>

      {/* Description */}
      <div
        style={{
          fontFamily: "Nexa-Regular",
          fontSize: 16,
          zIndex: 10,
          color: "whitesmoke",
          maxWidth: 600,
          margin: "0 16px",
        }}
      >
        <p style={{ marginTop: 30,textAlign:"center" }}>
          where little voices grow big dreams! Through fun, phonics, and play,
          we build strong foundations each day. Watch your child read, speak,
          and shine with confidence and joy. Start the journey today – learning
          begins the Little Learners way!
        </p>
      </div>
    </div>
  );
};

export default JoinUs;
